import { IonButton, IonIcon, IonProgressBar, IonText } from '@ionic/react';
import { checkmarkCircleOutline, cloudDownloadOutline } from 'ionicons/icons';
import React from 'react';

interface ActiveSearchWidgetProps {
    status: string;
    progressMessage: string;
    isComplete: boolean;
    totalJobs?: number;
    onViewResults: () => void;
    onDismiss: () => void;
}

const ActiveSearchWidget: React.FC<ActiveSearchWidgetProps> = ({
    status,
    progressMessage,
    isComplete,
    totalJobs,
    onViewResults,
    onDismiss
}) => {
    return (
        <div className="glass-card" style={{
            padding: '12px 16px',
            marginBottom: '16px',
            marginTop: '-16px', // Pull it up closer to search bar
            borderTopLeftRadius: '0',
            borderTopRightRadius: '0',
            borderTop: 'none',
            background: isComplete ? 'rgba(16, 185, 129, 0.05)' : 'rgba(255, 255, 255, 0.8)',
            borderColor: isComplete ? 'rgba(16, 185, 129, 0.2)' : undefined,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '12px',
            animation: 'slideDown 0.3s ease-out forwards'
        }}>
            <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
                    <IonIcon
                        icon={isComplete ? checkmarkCircleOutline : cloudDownloadOutline}
                        style={{
                            color: isComplete ? 'var(--ion-color-success)' : 'var(--ion-color-primary)',
                            fontSize: '18px'
                        }}
                    />
                    <IonText style={{
                        fontSize: '14px',
                        fontWeight: '600',
                        color: isComplete ? 'var(--ion-color-success)' : 'var(--ion-text-color)'
                    }}>
                        {isComplete ? 'Search Complete' : 'Search in Progress'}
                    </IonText>
                </div>

                <div style={{ fontSize: '13px', color: 'var(--ion-color-medium)', display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {progressMessage}
                    </span>
                </div>

                {!isComplete && (
                    <IonProgressBar
                        type="indeterminate"
                        color="primary"
                        style={{ height: '2px', borderRadius: '2px', marginTop: '8px', maxWidth: '200px' }}
                    />
                )}
            </div>

            {isComplete ? (
                <IonButton
                    size="small"
                    color="success"
                    fill="solid"
                    onClick={onViewResults}
                    style={{ '--border-radius': '8px', height: '32px', fontSize: '13px', fontWeight: '600' }}
                >
                    View {totalJobs} Jobs
                </IonButton>
            ) : (
                <IonButton
                    size="small"
                    fill="clear"
                    onClick={onDismiss}
                    color="medium"
                    style={{ height: '32px', fontSize: '12px' }}
                >
                    Hide
                </IonButton>
            )}

            <style>{`
        @keyframes slideDown {
          from { transform: translateY(-10px); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
      `}</style>
        </div>
    );
};

export default ActiveSearchWidget;
